module.exports = __webpack_public_path__ + "img/ga-preview.eaeda530.png";